<div class="notification-bar" [ngClass]="notification.status + '-notification'">
  <div>
    <span [innerHTML]="notification.message|safeHtml"></span>
    <p><a [routerLink]="notification.link.route" *ngIf="notification?.link">{{notification.link.label}}</a></p>
  </div>
  <p-button variant="text" severity="info" (click)="dismiss()" aria-label="Dismiss">{{notification.close}} <i class="fa-solid fa-times"></i></p-button>
</div>
